const loadAsyncScript = src => {
    let script = document.createElement("script")
    script.src = src
    script.async = true
    document.body.appendChild(script)
}

export { loadAsyncScript }
